module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__estado_White.612b854b.svg";